import React from 'react'

export default function DetailList({ items = [] }) {
  const visibleItems = items.filter(({ value }) => value)

  return (
    <div className="flex flex-col">
      {
        visibleItems.map(({ icon: Icon, label, value }) => (
          <div key={label} className="flex items-center justify-between gap-4 py-2">
            <span className="flex items-center gap-4 text-base text-secondary shrink-0">
              {Icon && <Icon size={24} className="text-secondary shrink-0" />}
              {label}
            </span>

            <span className="text-base text-dark-blue text-right">{value}</span>
          </div>
        ))
      }
    </div>
  )
}
